export const BILLING_RECOVERY_ROUTE_PREFIXES = ["/app/settings/account", "/app/subscription-success", "/app/billing"] as const;

export function isBillingRecoveryRoute(pathname: string | null | undefined): boolean {
  if (!pathname) return false;
  const path = pathname.length > 1 ? pathname.replace(/\/+$/, "") : pathname;
  return BILLING_RECOVERY_ROUTE_PREFIXES.some((prefix) => path === prefix || path.startsWith(`${prefix}/`));
}
